import { observer } from "mobx-react";
import React from "react";
import { Title, Modal, Stack, Text } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import {
  JsonView,
  allExpanded,
  collapseAllNested,
  darkStyles,
} from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import { MODALS } from "../../helpers/constants";
import SendFundsAdvanced from "../sendFundsAdvanced";
import SendFunds from "../sendFunds";
import { TextWithInfo } from "./textWithInfo";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";
import { IconArrowBigUpFilled, IconKey } from "@tabler/icons-react";

const SendFundsModal = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <>
      <Modal
        opened={cubby.currentModal === MODALS.SEND_BTC}
        onClose={() => cubby.setModal(null)}
        title={
          <TextWithInfoAndIcon
            text="Withdraw BTC On-Chain"
            articleSlug={ARTICLES.WITHDRAW_BTC.slug}
            icon={<IconArrowBigUpFilled size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        {cubby.isAdvancedMode && <SendFundsAdvanced cubby={cubby} />}

        {!cubby.isAdvancedMode && <SendFunds cubby={cubby} />}
      </Modal>
    </>
  );
});

export default SendFundsModal;
